(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["POR-Details2"] && !Shopify.designMode) return;
  try {
    
/* SHAPEDHERITAGE — no dependencies. One definition supports multiple instances. */
(() => {
  const tag = 'sh-details-carousel';
  if (customElements.get(tag)) return;
  class SHDetailsCarousel extends HTMLElement {
    connectedCallback() {
      // Wait for children when the already-registered element is parsed or inserted again.
      if (this._abort || this._connectFrame) return;
      this._connectFrame = requestAnimationFrame(() => {
        this._connectFrame = 0;
        if (this.isConnected) this.initialize();
      });
    }
    initialize() {
      if (this._abort) return;
      this.viewport = this.querySelector('[data-shd-viewport]');
      this.track = this.querySelector('[data-shd-track]');
      if (!this.viewport || !this.track) return;
      this._abort = new AbortController();
      this.slides = [...this.querySelectorAll('[data-shd-slide]')];
      this.dots = [...this.querySelectorAll('[data-shd-dot]')];
      this.prev = this.querySelector('[data-shd-prev]');
      this.next = this.querySelector('[data-shd-next]');
      this.status = this.querySelector('[data-shd-status]');
      this.index = this.index || 0;
      this.x = 0;
      this.positions = [0];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const on = (el, type, fn, options = {}) => el?.addEventListener(type, fn, { ...options, signal:this._abort.signal });
      on(this.prev, 'click', () => this.go(this.index - 1));
      on(this.next, 'click', () => this.go(this.index + 1));
      this.dots.forEach((dot, i) => on(dot, 'click', () => this.go(i)));
      on(this.viewport, 'keydown', e => {
        if (e.ctrlKey || e.metaKey || e.altKey) return;
        if (e.target.closest('a, button, input, textarea, select, [contenteditable]')) return;
        const changes = {ArrowLeft:this.index - 1, ArrowRight:this.index + 1, Home:0, End:this.positions.length - 1};
        if (!(e.key in changes)) return;
        e.preventDefault(); this.go(changes[e.key]);
      });
      on(this.viewport, 'focusin', e => {
        const slide = e.target.closest('[data-shd-slide]');
        if (!slide) return;
        this.viewport.scrollLeft = 0;
        const target = Math.min(slide.offsetLeft, this.max);
        const index = this.positions.reduce((best, p, i) => Math.abs(p - target) < Math.abs(this.positions[best] - target) ? i : best, 0);
        this.go(index, false);
      });
      if (this.dataset.dragEnabled === 'true') {
        on(this.viewport, 'pointerdown', e => {
  if (e.pointerType !== 'touch') this.pointerDown(e);
});

let swipe = null;

const endSwipe = cancelled => {
  const gesture = swipe;
  swipe = null;
  if (!gesture?.horizontal) return;

  const distance = gesture.dx;
  const flick = this.dataset.flickEnabled === 'true'
    && Math.abs(distance) > 28
    && Math.abs(distance) / Math.max(1, performance.now() - gesture.time) > 0.6;
  const advance = !cancelled && (Math.abs(distance) >= this.threshold() || flick);
  this.go(this.index + (advance ? (distance < 0 ? 1 : -1) : 0));
};

on(this.viewport, 'touchstart', e => {
  if (e.touches.length !== 1) {
    endSwipe(true);
    return;
  }
  if (this.positions.length < 2) return;
  if (e.target.closest('a, button, input, select, textarea, [contenteditable]')) return;

  const finger = e.touches[0];
  swipe = { x: finger.clientX, y: finger.clientY, time: performance.now() };
}, { passive: true });

on(this.viewport, 'touchmove', e => {
  if (!swipe || e.touches.length !== 1) return;

  const finger = e.touches[0];
  const dx = finger.clientX - swipe.x;
  const dy = finger.clientY - swipe.y;

  if (!swipe.horizontal) {
    if (Math.max(Math.abs(dx), Math.abs(dy)) < 7) return;
    if (Math.abs(dx) <= Math.abs(dy) || !e.cancelable) {
      swipe = null;
      return;
    }
    clearTimeout(this.wheelTimer);
    this.wheelState = null;
    this.stop();
    swipe.base = this.x;
    swipe.horizontal = true;
  }

  if (e.cancelable) e.preventDefault();
  swipe.dx = dx;
  this.paint(this.pull(swipe.base, dx));
}, { passive: false });

on(this.viewport, 'touchend', () => endSwipe(false));
on(this.viewport, 'touchcancel', () => endSwipe(true));
        on(this.viewport, 'pointermove', e => this.pointerMove(e), { passive:false });
        on(this.viewport, 'pointerup', e => this.pointerEnd(e, false));
        on(this.viewport, 'pointercancel', e => this.pointerEnd(e, true));
        on(this.viewport, 'lostpointercapture', e => this.pointerEnd(e, true));
        on(this.viewport, 'pointerleave', e => {
          if (this.pointer && !this.pointer.locked) this.pointerEnd(e, true);
        });
        on(this.viewport, 'dragstart', e => e.preventDefault());
        on(this.viewport, 'click', e => {
          if (Date.now() < (this.suppressClickUntil || 0)) { e.preventDefault(); e.stopImmediatePropagation(); }
        }, { capture:true });
      }
      if (this.dataset.wheelEnabled === 'true') on(this.viewport, 'wheel', e => this.wheel(e), { passive:false });
      on(document, 'shopify:block:select', e => {
        const index = this.slides.findIndex(s => s.dataset.blockId === String(e.detail?.blockId));
        if (index < 0 || !this.contains(e.target)) return;
        this.measure();
        const target = Math.min(this.slides[index].offsetLeft, this.max);
        const snap = this.positions.reduce((best, p, i) => Math.abs(p - target) < Math.abs(this.positions[best] - target) ? i : best, 0);
        this.go(snap, false);
      });
      this._resize = new ResizeObserver(() => this.measure());
      this._resize.observe(this.viewport);
      this.measure();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this._connectFrame); this._connectFrame = 0;
      this._abort?.abort(); this._abort = null;
      this._resize?.disconnect(); this.stop();
      clearTimeout(this.wheelTimer);
      if (this.pointer && this.viewport?.hasPointerCapture(this.pointer.id)) this.viewport.releasePointerCapture(this.pointer.id);
      this.pointer = null; this.wheelState = null;
      this.removeAttribute('data-dragging');
    }
    stop() {
      cancelAnimationFrame(this.frame); this.frame = 0;
      this.removeAttribute('data-moving');
    }
    paint(x) {
      this.x = x;
      this.track.style.transform = 'translate3d(' + x.toFixed(3) + 'px,0,0)';
    }
    measure() {
      if (!this.viewport.clientWidth) return;
      const mobile = matchMedia('(max-width:749px)').matches;
      const padding = Number(mobile ? this.dataset.mobilePad : this.dataset.pad);
      const inner = Math.min(Number(this.dataset.maxWidth), this.clientWidth - 2 * padding);
      const percent = Number(mobile ? this.dataset.mobileWidth : this.dataset.cardWidth);
      const width = Math.max(100, inner * percent / 100);
      this.style.setProperty('--shd-actual-width', width + 'px');
      this.max = Math.max(0, this.track.scrollWidth - this.viewport.clientWidth);
      const points = this.slides.map(s => Math.min(s.offsetLeft, this.max));
      this.positions = points.filter((x, i) => i === 0 || Math.abs(x - points[i - 1]) > 1);
      if (!this.positions.length) this.positions = [0];
      this.index = Math.min(this.index, this.positions.length - 1);
      this.stop();
      clearTimeout(this.wheelTimer); this.wheelState = null;
      if (this.pointer) {
        const id = this.pointer.id; this.pointer = null;
        if (this.viewport.hasPointerCapture(id)) this.viewport.releasePointerCapture(id);
        this.removeAttribute('data-dragging');
      }
      this.viewport.scrollLeft = 0;
      this.paint(-this.positions[this.index]);
      this.setAttribute('data-ready', ''); this.update();
    }
    update(announce = false) {
      const count = this.positions.length;
      if (this.prev) this.prev.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index >= count - 1;
      this.querySelectorAll('[data-shd-controls]').forEach(el => el.hidden = count < 2);
      this.dots.forEach((dot, i) => {
        dot.hidden = i >= count;
        dot.setAttribute('aria-label', 'Ansicht ' + (i + 1) + ' von ' + count);
        if (i === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
      if (announce && this.status) this.status.textContent = 'Ansicht ' + (this.index + 1) + ' von ' + count;
    }
    go(index, animate = true) {
      if (!this.positions.length) return;
      clearTimeout(this.wheelTimer); this.wheelState = null;
      this.index = Math.max(0, Math.min(index, this.positions.length - 1));
      this.update(true);
      const target = -this.positions[this.index];
      this.stop();
      if (!animate || this.motion.matches || Math.abs(target - this.x) < .2) { this.paint(target); return; }
      // A damped spring, rather than a fixed CSS easing, also handles release between slides.
      const duration = Number(this.dataset.duration) / 1000;
      const omega = 9 / duration;
      const stiffness = omega * omega;
      const damping = 1.7 * omega;
      let velocity = 0, last = performance.now(), started = last;
      this.setAttribute('data-moving', '');
      const tick = now => {
        const dt = Math.min(.032, Math.max(.001, (now - last) / 1000)); last = now;
        velocity += ((target - this.x) * stiffness - velocity * damping) * dt;
        this.paint(this.x + velocity * dt);
        if ((Math.abs(target - this.x) < .15 && Math.abs(velocity) < 2) || now - started > 2400) {
          this.paint(target); this.stop(); return;
        }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    threshold() {
      return Math.max(28, this.slides[0]?.getBoundingClientRect().width * Number(this.dataset.threshold) / 100 || 60);
    }
    pull(base, dx) {
      const desired = base + dx * Number(this.dataset.response) / 100;
      const upper = -this.positions[Math.max(0, this.index - 1)];
      const lower = -this.positions[Math.min(this.positions.length - 1, this.index + 1)];
      const limit = Math.min(100, this.viewport.clientWidth * .18);
      const rubber = n => limit * (1 - Math.exp(-n / limit));
      if (desired > upper) return upper + rubber(desired - upper);
      if (desired < lower) return lower - rubber(lower - desired);
      return desired;
    }
    pointerDown(e) {
      if (!e.isPrimary || e.button !== 0 || this.positions.length < 2 || this.pointer) return;
      if (e.target.closest('a, button, input, select, textarea, [contenteditable]')) return;
      clearTimeout(this.wheelTimer); this.wheelState = null;
      this.stop();
      this.pointer = {id:e.pointerId, x:e.clientX, y:e.clientY, base:this.x, dx:0, time:performance.now(), locked:false};
    }
    pointerMove(e) {
      const p = this.pointer;
      if (!p || p.id !== e.pointerId) return;
      const dx = e.clientX - p.x, dy = e.clientY - p.y;
      if (!p.locked) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 7) return;
        if (Math.abs(dy) > Math.abs(dx) * 1.15) { this.pointer = null; this.go(this.index); return; }
        if (Math.abs(dx) < Math.abs(dy) * 1.15) return;
        p.locked = true;
        this.viewport.setPointerCapture(e.pointerId);
        this.setAttribute('data-dragging', '');
      }
      e.preventDefault(); p.dx = dx;
      this.paint(this.pull(p.base, dx));
    }
    pointerEnd(e, cancelled) {
      const p = this.pointer;
      if (!p || p.id !== e.pointerId) return;
      this.pointer = null;
      this.removeAttribute('data-dragging');
      if (this.viewport.hasPointerCapture(p.id)) this.viewport.releasePointerCapture(p.id);
      const distance = p.dx;
      const flick = this.dataset.flickEnabled === 'true' && Math.abs(distance) > 28 && Math.abs(distance) / Math.max(1, performance.now() - p.time) > .6;
      if (p.locked) this.suppressClickUntil = Date.now() + 300;
      const step = !cancelled && p.locked && (Math.abs(distance) >= this.threshold() || flick) ? (distance < 0 ? 1 : -1) : 0;
      this.go(this.index + step);
    }
    wheel(e) {
      if (this.positions.length < 2 || this.pointer) return;
      // Only horizontal gestures (or Shift+wheel) belong to the gallery. Vertical page scrolling stays native.
      const horizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
      if (!horizontal) return;
      e.preventDefault();
      const unit = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? this.viewport.clientWidth : 1;
      if (!this.wheelState) { this.stop(); this.wheelState = {base:this.x, dx:0}; }
      this.wheelState.dx -= horizontal * unit;
      this.paint(this.pull(this.wheelState.base, this.wheelState.dx));
      clearTimeout(this.wheelTimer);
      this.wheelTimer = setTimeout(() => {
        if (!this.wheelState) return;
        const distance = this.wheelState.dx;
        this.wheelState = null;
        const step = Math.abs(distance) >= this.threshold() ? (distance < 0 ? 1 : -1) : 0;
        this.go(this.index + step);
      }, 140);
    }
  }
  customElements.define(tag, SHDetailsCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
